import React, { useEffect, useState } from 'react'
import { Link,useNavigate,useLocation } from 'react-router-dom'
import "./ByBookPackage.css"
import Navbar from '../../Navbar/Navbar'
import Stepper from '../Stepper/Stepper'
import { useGetAddOnQuery, useGetSlotTimeQuery } from '../../../../Redux/Api/AuthApi'
import ReactMarkdown from "react-markdown";
import { useDispatch } from 'react-redux'
import { partBookingDetails } from '../../../../Redux/Slice/AuthSlice'

const ByBookPackage = () => {

  const [slotData,setSlotData] = useState()
  const {data,isSuccess} = useGetSlotTimeQuery()
  const response = useGetAddOnQuery()
  const location = useLocation();
  const dispatch = useDispatch()
  const partydate = location.state;
  const navigate = useNavigate()

  useEffect(()=>{
    if(isSuccess){
      setSlotData(data?.data[0])
    }
  },[setSlotData,data,isSuccess])
  

  const handleSubmit = (e)=>{
    e.preventDefault()
    let data = {...slotData,partydate}
    if(response?.data?.data?.length < 1){
    dispatch(partBookingDetails(JSON.stringify({data:slotData,message:'package'})))
    navigate('/portal/booking/party/details',{state:data})
    }
    dispatch(partBookingDetails(JSON.stringify({data:slotData,message:'package'})))
    navigate('/portal/booking/party/add-on',{state:data})
  }
  return (
    <div className="kiga-portal-package-main">
     <Navbar />
     <div className="kiga-portal-package-head-title">
      <p>Party Booking</p>
     </div>
     <Stepper/>
     <section className='kiga-portal-package-section'>
      <div className='kiga-portal-package-section-title'>
        <h5>step 3</h5>
        <p>Choose a Package</p>
      </div>
       <div className='kiga-portal-package-section-card'>
        <div className='kiga-portal-package-section-card-content-image'>
        <div className='kiga-portal-package-section-card-image'>
          <img src='/images/Gallery/holiday.jpg' alt='slot-pc'/>
         </div>
        </div>
         <div className='kiga-portal-package-section-card-content'>
          <div className='kiga-portal-package-section-card-content-head'>
           <div><Link to='/portal/booking/party/checkout'>{slotData?.name}</Link></div>
           <div><p>{slotData?.basePrice} Rwf</p></div>
          </div>
          <div className='kiga-portal-package-section-card-content-info'>
            <ReactMarkdown>{slotData?.description}</ReactMarkdown>
          </div>
         <div className='kiga-portal-package-section-card-content-btn'>
            <button onClick={handleSubmit}>Add Package</button>
          </div>
         </div>
       </div>
     </section>
    </div>
  )
}

export default ByBookPackage